import { render, staticRenderFns } from "./CollegeSubscriptionMockTestTopic.vue?vue&type=template&id=2c002828&scoped=true"
import script from "./CollegeSubscriptionMockTestTopic.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionMockTestTopic.vue?vue&type=script&lang=js"
import style0 from "./CollegeSubscriptionMockTestTopic.vue?vue&type=style&index=0&id=2c002828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c002828",
  null
  
)

export default component.exports